<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.BillExchangeAgent')"
    width="600px"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width: 100%;min-height: 350px;"
    />
    <span slot="footer">
      <el-button v-show="selectedRow && (!selectedRow.sendTime || selectedRow.allowAgainSend)" no="SendEmail" type="primary" @click="onSendEmail">{{ $t('FileHistory.SendEmail') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as jobExchangeAgentApi from '@/api/booking/jobExchangeAgent'

export default {
  name: 'ExchangeAgentSelectDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true },
    exchangeAgents: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          // 清除单选
          event.api.clearFocusedCell()
        },
        onCellFocused: (event) => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        }
      },
      columnDefs: [
        {
          headerName: this.$t('FileHistory.ProxyName'),
          field: 'exchangeAgent',
          width: 350,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.sendingTime'),
          field: 'sendTime',
          width: 200
        }
      ],
      rowData: [],
      selectedNode: null
    }
  },
  computed: {
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
      }
    }
  },
  methods: {
    async init() {
      const res = await jobExchangeAgentApi.getList({ jobUuid: this.jobUuid })
      const itemMap = new Map()
      for (const item of res.data) {
        itemMap.set(item.exchangeAgent, item)
      }
      for (const exchangeAgent of this.exchangeAgents) {
        if (itemMap.has(exchangeAgent)) {
          this.rowData.push(itemMap.get(exchangeAgent))
        } else {
          this.rowData.push({ uuid: '', exchangeAgent, sendTime: '', allowAgainSend: false })
        }
      }
    },
    onSendEmail() {
      this.innerVisible = false
      this.$emit('callback', this.selectedRow)
    }
  }
}
</script>
